import * as selectStyles from "./MultiSelect.less";
import * as viewerStyles from "./MultiSelectValuesView.less";

export const InlineMultiSelectClasses = {
    viewer: viewerStyles.inline_edit,
    popover: selectStyles.inline_edit_wrapper,
} as const;
